__turbopack_context__.v({
  "buy-dialog": "index-module-scss-module__ouP8sa__buy-dialog",
  "iframe": "index-module-scss-module__ouP8sa__iframe",
  "iframe-container": "index-module-scss-module__ouP8sa__iframe-container",
  "some": "index-module-scss-module__ouP8sa__some",
  "weight-book": "index-module-scss-module__ouP8sa__weight-book",
});
